import * as z from "zod";
import { hooksBlockStatusSchema } from "./get-hooks-overview";

export const hooksExpansionDealSchema = z.object({
  hubspotId: z.string(),
  dealName: z.string().nullable(),
  teamId: z.string(),
  merchantName: z.string(),
  storeUrl: z.string().nullable(),
  /** Raw HubSpot multi-select tokens; the vocabulary lives in HubSpot. */
  products: z.array(z.string()),
  stageLabel: z.string().nullable(),
  isClosedWon: z.boolean(),
  isClosedLost: z.boolean(),
  valueCents: z.number(),
  createdAt: z.date(),
  closedAt: z.date().nullable(),
  /** Created after the merchant's first hook activation. Pre-hook deals are
   * returned but flagged, so nothing silently disappears. */
  attachedAfterHook: z.boolean(),
});

export const getHooksExpansionDeals = {
  name: "getHooksExpansionDeals" as const,
  input: z.object({
    /** Restrict to one merchant; omitted means the whole hook-first cohort. */
    teamId: z.string().optional(),
  }),
  output: z.object({
    status: hooksBlockStatusSchema,
    deals: z.array(hooksExpansionDealSchema),
    truncated: z.boolean(),
  }),
};

export type GetHooksExpansionDealsOutput = z.infer<
  typeof getHooksExpansionDeals.output
>;
